function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgGooglePlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: props.color || 'currentColor',
  viewBox: "0 0 16 16",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "m8.36 7.642-6.618 7.03a1.79 1.79 0 0 0 2.638 1.076l.018-.012 7.453-4.299-3.49-3.8v.005Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M15.067 6.448h-.006l-3.216-1.873-3.627 3.229 3.639 3.64 3.204-1.848c.56-.305.94-.896.94-1.574a1.77 1.77 0 0 0-.934-1.568v-.006Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M1.742 1.334a1.89 1.89 0 0 0-.062.46v12.417c0 .162.018.312.062.46L8.59 7.824 1.74 1.335Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "m8.41 8.003 3.428-3.428L4.392.258a1.79 1.79 0 0 0-2.65 1.07L8.41 8.003Z"
}));
export default SvgGooglePlay;